import React from 'react';
import fr from 'facet-rest';
import { pick } from 'Helpers/Affordances';
import PropTypes from 'prop-types';
import { FDSecondaryActionButton } from '@facet-wealth/design';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';

const LearnMorePicker = ({
  resource,
}) => {
  const { loadModalCollectionByLink } = useModalContext();

  return pick(resource, {
    [fr.relationships.specificPageLink.name]: (
      <FDSecondaryActionButton
        onClick={() => loadModalCollectionByLink(resource?.relationship(fr.relationships.specificPageLink.name)?.link('related').url())}
        label={resource?.relationship(fr.relationships.specificPageLink.name)?.meta('prompt') || 'Learn More'}
      />
    ),
  }, null);
};

LearnMorePicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

LearnMorePicker.defaultProps = {};

export default LearnMorePicker;
